var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeactiveAllFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4.5H13.5M5.5 8H13.5M5.5 11.5H13.5M2.5 4.5H2.505V4.505H2.5V4.5ZM2.75 4.5C2.75 4.63807 2.63807 4.75 2.5 4.75C2.36193 4.75 2.25 4.63807 2.25 4.5C2.25 4.36193 2.36193 4.25 2.5 4.25C2.63807 4.25 2.75 4.36193 2.75 4.5ZM2.5 8H2.505V8.005H2.5V8ZM2.75 8C2.75 8.13807 2.63807 8.25 2.5 8.25C2.36193 8.25 2.25 8.13807 2.25 8C2.25 7.86193 2.36193 7.75 2.5 7.75C2.63807 7.75 2.75 7.86193 2.75 8ZM2.5 11.5H2.505V11.505H2.5V11.5ZM2.75 11.5C2.75 11.6381 2.63807 11.75 2.5 11.75C2.36193 11.75 2.25 11.6381 2.25 11.5C2.25 11.3619 2.36193 11.25 2.5 11.25C2.63807 11.25 2.75 11.3619 2.75 11.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactiveAllFilter);
export default __webpack_public_path__ + "static/media/deactive-all-filter.3afeebbad361bca561823f428e17e256.svg";
export { ForwardRef as ReactComponent };